import { useEffect } from 'react';
import useExposureEvent from '@alltrails/experiments/hooks/useExposureEvent';
import useIsSeoOrViralityTraffic from '@/hooks/useIsSeoOrViralityTraffic';
import useScrollAuthAltTreatment from '@/hooks/useScrollAuthAltTreatment';

// Fires the scroll-auth exposure for eligible users. Call from exactly ONE place
// (ViewLimitHandler) so the event is sent once per page view.
const useScrollAuthAltExposure = (isBot: boolean) => {
  const { isEligible } = useScrollAuthAltTreatment(isBot);
  const isSeoOrViralityTraffic = useIsSeoOrViralityTraffic();
  const sendDirectExposure = useExposureEvent('web-growth-rm-scroll-auth-mweb-v2-direct');
  const sendSeoExposure = useExposureEvent('web-growth-rm-scroll-auth-mweb-v2-seo');

  useEffect(() => {
    if (!isEligible) {
      return;
    }
    if (isSeoOrViralityTraffic) {
      sendSeoExposure();
    } else {
      sendDirectExposure();
    }
  }, [isEligible, isSeoOrViralityTraffic, sendSeoExposure, sendDirectExposure]);
};

export default useScrollAuthAltExposure;
